import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useHistory, useParams} from "react-router-dom";
import {Button, Card, CardBody, Row} from "reactstrap";

import Layout from "../../layout/layout";
import Breadcrumb from "../../components/common/Breadcrumb";
import Plant from "../../components/formViews/Plant";

import OrchardRegisterListSub from "../OrchardEntries/OrchardRegisterListSub";
import {useDispatch, useSelector} from "react-redux";
import {getSystemPlantData} from "../../redux/actions/systemPlantActions";
import {getSystemData} from "../../redux/actions/systemActions";


const PlantView = () => {

    const {t} = useTranslation();
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();

    const available = useSelector((el) => el.systemData.availableList)
    const systemPlantData = useSelector((el)=> el.systemPlantData.systemPlantData)
    const errorData = useSelector((el) => el.loadingData.error)
    const role = useSelector((state) => state.authData?.userDetails?.role)
    const systemData = useSelector((el) => el.systemData.systemData)

    const [formState, setFormState] = useState({
        name: '',
        category: '',
        species: '',
        systemArea: '',
        vegetationMinTemp: null,
        vegetationMaxTemp: null,
        waterEcMax: null,
        notes: '',
        geoLocation: null
    })

    useEffect(() => {
        if(!available.some((el) => el._id === params.systemId)){
            history.push(`/systems`)
        } else {
            dispatch(getSystemPlantData(params.plantId, params.systemId))
            dispatch(getSystemData(params.systemId))
        }
    }, [])

    useEffect(() => {
        if (systemPlantData) {
            setFormState({
                name: systemPlantData.name,
                category: systemPlantData.category?.name,
                species: systemPlantData.species?.name,
                systemArea: systemPlantData.systemarea?.name,
                vegetationMinTemp: systemPlantData.vegetation_min_temp,
                vegetationMaxTemp: systemPlantData.vegetation_max_temp,
                waterEcMax: systemPlantData.water_ec_max,
                notes: systemPlantData.notes,
                geoLocation: systemPlantData?.geoposition ? {
                    lat: systemPlantData?.geoposition?.coordinates[0],
                    lng : systemPlantData?.geoposition?.coordinates[1]
                } : null
            })
        }
    }, [systemPlantData])

    useEffect(() => {
        if (errorData && errorData.code === 404 ) {
            history.push(`/system/${params.systemId}/plants`)
        }
    }, [errorData])


    return (
        <Layout>
            <div>
                <Breadcrumb
                    title={t(formState.name)}
                    breadcrumbItems={[
                        {path: `system/view/${params.systemId}`, name: t(available.find((el) => el._id === params.systemId)?.name)},
                        {path: `system/${params.systemId}/plants`, name: t('plants.breadcrumb1')},
                        {path: `system/${params.systemId}/plant/view/${params.plantId}`, name: t(formState.name)},
                    ]}
                />

                <Card>
                    <CardBody>
                        <div className='row'>
                            <div className={role === 'customer' || role === 'guest' ? 'col-12' : 'col-md-6'}>
                                <Plant
                                    systemPolygon={systemData?.metadata?.geoposition?.coordinates[0]}
                                    formState={formState}
                                    role={role}
                                />
                                <div className='col-12 pb-5 text-end mt-3 form-btn-grp'>
                                    <Link to={`/system/${params.systemId}/plants`}><Button type='button' className='btn-secondary'>{t('main.back')}</Button></Link>
                                </div>
                            </div>
                            {(role === 'admin' || role.includes('supervisor')) &&
                                <div className='col-md-6'>
                                    <OrchardRegisterListSub />
                                </div>
                            }
                        </div>
                    </CardBody>
                </Card>

            </div>
        </Layout>
    )
}

export default PlantView;